/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecordExportType {
  CASE = 'case',
  TASK = 'task',
  NOTE = 'note',
  DOCUMENT = 'document',
  ATTACHMENT = 'attachment',
  PAGE = 'page',
  ACCOUNT = 'account',
  LEAD = 'lead',
  CONTACT = 'contact',
  EVENT = 'event',
  USER = 'user',
  OPPORTUNITY = 'opportunity',
}
